/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  font-size: 0.8571428571rem;
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  padding: 0;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  border: 0.0714285714rem solid;
  border-color: #8E989D;
  border-color: var(--davinci-color-outline, #8E989D);
}
:host .wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: center;
  padding: 0 0.5714285714rem;
}
:host .wrapper .icon {
  width: 1.2857142857rem;
  height: 1.2857142857rem;
  margin-right: 0.5714285714rem;
  fill: #50585C;
  fill: var(--davinci-color-text-light, #50585C);
}
:host .wrapper .slotwrapper {
  line-height: 1.7142857143rem;
  flex: 1 1 auto;
}
:host .wrapper:focus {
  outline: none;
}

:host([type=filter]) .close {
  display: block;
}

:host([type=filter]:hover) {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}

:host([type=filter]:active),
:host([type=filter]:focus) {
  border-color: #007CC1;
  border-color: var(--davinci-color-primary, #007CC1);
  background-color: #e5f6ff;
  background-color: var(--davinci-color-item-focus, #e5f6ff);
}

:host([hidden]) {
  display: none;
}`;
export { style };
